import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { PageTopbar } from "../../../components/Page/Topbar";
import { PageHeader } from "../../../components/Page/Header";
import { AppArticlesRepairsDetails } from "../../../app/Articles/Repairs/Details";
import { getPageTitle } from "../../../app/helpers/global";

export function RoutesArticlesRepairsDetails({ parents, current }) {

    let identifier = (parents + current).replaceAll('/', '-');
    const { repairId } = useParams();
    const [title, setTitle] = useState(null);

    if (title === null) {
        getPageTitle('repair', repairId, setTitle);
    }

    return (
        <div>

            <PageTopbar
                parents={parents}
                current={current}
            />

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                variables={{ repairId: repairId }}
                identifier={identifier}
            />

            <AppArticlesRepairsDetails
                repairId={repairId}
                identifier={identifier}
                parents={parents}
            />
        </div>
    );
}